import React from "react";
import WhatsappDefault from "../../assets/svg/WhatsappDefault";
import {
  TouchableHighlight,
  StyleSheet,
  ActivityIndicator,
  View,
} from "react-native";
import Caret from "../../assets/svg/Caret";
import Text from "../AppText";
import analytics from "@services/analytics";

const WhatsAppShare = ({
  title = "",
  titlePrice = "",
  wrapperStyles = {},
  medium = false,
  large = false,
  bold = false,
  semiBold = false,
  fontType = "content1",
  caret = true,
  onShare = () => {},
  fullWidth = false,
  textStyles = {},
  caretStroke = "#fff",
  eventName = "",
  eventProps = {},
  loading = false,
}) => {
  return (
    <TouchableHighlight
      underlayColor={"#054039"}
      style={[
        styles.whatsappButton,
        { width: fullWidth ? "85%" : large ? 290 : medium ? 115 : 140 },
        wrapperStyles,
      ]}
      onPress={() => {
        if (eventName) {
          analytics.trackEvent(eventName, {
            ...eventProps,
          });
        }
        onShare();
      }}
    >
      <View style={styles.inner}>
        <WhatsappDefault />
        <Text
          style={[styles.text, { paddingHorizontal: 4, ...textStyles }]}
          bold={bold}
          semiBold={semiBold}
          fontType={fontType}
        >
          {title}
        </Text>
        <Text
          style={[
            styles.text,
            {
              ...textStyles,
              fontWeight: "bold",
              paddingLeft: 0,
              marginLeft: 0,
            },
          ]}
          bold={bold}
          semiBold={semiBold}
          fontType={fontType}
        >
          {titlePrice}
        </Text>
        {loading && <ActivityIndicator color={"#fff"} />}
        {caret && !loading && <Caret strokeColor={caretStroke} />}
      </View>
    </TouchableHighlight>
  );
};

const styles = StyleSheet.create({
  whatsappButton: {
    backgroundColor: "#075E54",
    flexDirection: "row",
    borderRadius: 27,
    height: 36,
    alignItems: "center",
    justifyContent: "center",
    paddingHorizontal: 12,
  },
  text: {
    color: "#fff",
  },
  inner: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
  },
});

export default WhatsAppShare;
